import './DetailedLaundry.css'
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getTranslatedText as translate } from '../../Localization/Translation';
import { useSelector } from 'react-redux';
import { useBetween } from 'use-between';

function DetailedLaundry() {
    const { locale } = useBetween(useSelector(state => state.useSharedLang));
    // const {modalDetailsOrderId, setModalDetailsOrderId} = useBetween(useSelector(state => state.useSharedLang));
    // Connect with api to get specified order details


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
    }

    const Laundry = {
        id: 1,
        name: 'اسم المغسل',
        rate: '3.4',
        fav: true,
        city: 'موقع المغسل',
        date: '25/12/2020',
        phone: '0968820968',
        services: [
            {
                serviceId: 1,
                itemType: 'كنزة',
                servicesOnItem: [
                    { serviceName: 'غسيل', servicePrice: '20.0' },
                    { serviceName: 'كوي', servicePrice: '30.0' }
                ],
                serviceWeight: 'خفيفة'
            },
            {
                serviceId: 2,
                itemType: 'قميص',
                servicesOnItem: [
                    { serviceName: 'غسيل', servicePrice: '20.0' }
                ],
                serviceWeight: 'خفيفة'
            },
            {
                serviceId: 3,
                itemType: 'سجاد',
                servicesOnItem: [
                    { serviceName: 'غسيل', servicePrice: '50.0' },
                ],
                serviceWeight: 'ثقيلة'
            }
        ]
    }



    return (
        <div className="LaundryModal">


            <div className='Laundry-Profile' dir={(locale === 'EN' || locale === 'HN') ? 'ltr' : 'rtl'}>

                {/* Laundry information header */}
                <div className='Laundry-Information-in-modal'>
                    <div className='laundry-name-fav-profile'>

                        {/* name and fav column */}
                        <div className='laundry-name-fav-col-profile'>
                            <h5 className='laundry-name-profile'>{Laundry.name}</h5>
                        </div>

                        {/* Laundry rate row */}
                        <div className='laundry-name-fav-col-profile'>
                            <p className="card-text card-star-icon">
                                <span>{Laundry.rate}</span>
                                <span>/5.0</span>
                                <i className="bi bi-star-fill star-icon-rate"></i>
                            </p>
                        </div>

                    </div>

                    {/* phone and location column */}
                    <div className='laundry-phone-location-profile'>
                        <div>
                            <span><i className="bi bi-telephone-fill"></i></span>
                            <span>{Laundry.phone}</span>
                        </div>
                    </div>
                </div>
                <div className='Laundry-date-in-modal' dir='auto'>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <span>{translate('date-of-join', locale)}:</span>
                    <span>{Laundry.date}</span>
                </div>
                <div className='Laundry-date-in-modal' dir='auto'>
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                    <span>{translate('address', locale)}:</span>
                    <span>{Laundry.city}</span>
                </div>

                <div className='Laundry-Services-in-modal' dir='auto'>
                    <div className='d-flex justify-content-between align-items-center mb-1'>
                        <p className='Laundry-Services-profile-label'>
                            {translate('laundry-services-label', locale)}
                        </p>
                    </div>
                    <div className='table-container-notification'>
                        <table className="table" >
                            <thead className="thead-dark">
                                <tr className='table-notification-details-header'>
                                    <th scope="col">#</th>
                                    <th scope="col">{translate('item-type-column', locale)}</th>
                                    <th scope="col">{translate('services-laundry-table-column', locale)}</th>
                                    <th scope="col">{translate('size-laundry-table-column', locale)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Laundry.services.map((service, index) => {
                                        return (
                                            <tr key={service.serviceId} >
                                                <th scope="row">{index + 1}</th>
                                                <td>{service.itemType}</td>
                                                <td>{
                                                    service.servicesOnItem.map((serviceOnItem, indexType) => {
                                                        if (indexType !== service.servicesOnItem.length - 1)
                                                            return (
                                                                '(' + serviceOnItem.serviceName + ' , ' + serviceOnItem.servicePrice + ') - '
                                                            )
                                                        else
                                                            return (
                                                                '(' + serviceOnItem.serviceName + ' , ' + serviceOnItem.servicePrice + ')'
                                                            )
                                                    })
                                                }</td>
                                                <td>{service.serviceWeight}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <Modal show={show} onHide={handleClose} size='lg' dir='auto'>
                <Modal.Header className='request-service-header-modal'>
                    {translate('request-main-tab', locale)}
                </Modal.Header>
                <Modal.Body>
                </Modal.Body>
                <Modal.Footer dir="auto">
                    <Button variant="primary" className="btn"
                        onClick={handleClose}>
                        {translate('send-request-service', locale)}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default DetailedLaundry;
